import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 10",
  height: "48",
  width: "48",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5,4.806a.75.75,0,0,1-.75-.75V.75a.75.75,0,0,1,1.5,0V4.056A.75.75,0,0,1,5,4.806Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1),
    _createElementVNode("path", {
      d: "M5,10A5,5,0,0,1,1.667,1.274a.75.75,0,1,1,1,1.117,3.5,3.5,0,1,0,4.666,0,.75.75,0,1,1,1-1.117A5,5,0,0,1,5,10Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1)
  ])))
}
export default { render: render }